module.exports = __webpack_public_path__ + "img/Ing_microtech_01_TPA.b9db2c98.jpg";